import { createContext } from '../utils';
var ModalContext = createContext(null);
export default ModalContext;